<template lang="pug">
  .select-technician
    div
      //- BOTON ENTREGAR A TECNICO PARA REPARACION
      //- Da salida de bodega a un equipo asignado a un técnico para que lo repare (después de cotización aceptada)
      button.change-button(
        :disabled="disabled || loading"
        title="Entregar a técnico para reparación"
        data-testid="action-btn-entregar-tecnico-reparacion"
        @click="entregarATecnico()")
        b-spinner(v-if="loading" small)
        span {{ loading ? 'Procesando...' : 'Entregar a técnico para reparación' }}
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import LoadingButtonMixin from '@/mixins/LoadingButtonMixin'
import print from '@/utils/print'

export default {
  name: 'ActionEntregarTecnicoReparacion',
  mixins: [LoadingButtonMixin],
  props: ['ot', 'disabled'],

  data() {
    return {
      state: false,
      usuarios: [],
    }
  },
  methods: {
    ...mapActions('OTStore', ['entregarEquipoTecnico', 'getOT']),
    async entregarATecnico() {
      try {
        await this.executeWithLoading(async () => {
          const resp = await this.entregarEquipoTecnico({
            otId: this.ot.ot,
            technitianId: this.ot.tecnico_asignado.id,
          })
          if (resp.status === 200) {
            const partes = (resp.data && resp.data.partes_solicitadas) || []
            this.$bvToast.toast(
              `OT entregada a ${this.ot.tecnico_asignado.first_name} ${
                this.ot.tecnico_asignado.last_name
              }`,
              {
                variant: 'success',
              }
            )
            this.$emit('changed')
            if (partes.length > 0) {
              await this.imprimirPartes(partes)
            }
          } else {
            const detalle =
              (resp.data && (resp.data.mensaje || resp.data)) || 'sin detalle'
            this.$bvToast.toast(`Error al entregar el equipo: ${detalle}`, {
              variant: 'danger',
            })
          }
        })
      } catch (error) {
        console.error('Error al entregar equipo a técnico:', error)
        this.$bvToast.toast('Error al entregar equipo a técnico', {
          variant: 'danger',
        })
      }
    },
    async imprimirPartes(partes) {
      // Refresca la OT para que el papelito use el estado resultante de la acción
      let otActualizada = this.ot
      try {
        otActualizada = await this.getOT(this.ot.ot)
      } catch (error) {
        console.error('No se pudo refrescar la OT para imprimir:', error)
      }
      const now = moment().format('DD/MM/YYYY H:mm:ss')
      try {
        print(this.ot.ot, partes, otActualizada, now)
      } catch (error) {
        console.error('Error al imprimir el papelito de partes:', error)
      }
    },
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
  },
}
</script>
